module.exports = __webpack_public_path__ + "static/media/dontDelete.d31613c5.svg";